export const roundToTwoDecimalPlaces = (num: number): number => {
  const rounded = Math.round(num * 1000) / 1000;
  return Math.round(rounded * 100) / 100;
};

export const roundValue = (value: number | string): string => {
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "0.00";
  const thirdDecimal = Math.floor(num * 1000) % 10;
  return thirdDecimal >= 5 ? (Math.ceil(num * 100) / 100).toFixed(2) : num.toFixed(2);
};
